import * as React from 'react'

export const ActionsBar: React.SFC<{justifyContent?: string, margin?: string}> = (props) => (
    <div style={
        {   display: 'flex', 
            width: '100%', 
            justifyContent: props.justifyContent ? props.justifyContent : 'flex-end', 
            margin: props.margin ? props.margin : '1rem 0' }
    }>
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/shared/ActionsBar/ActionsBar.tsx